module.exports = __webpack_public_path__ + "img/likeztobatstuff.fdd37676.png";